import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TemaService } from 'new-sysman-ui';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [TranslateModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'sysman-web-sp-angular-19';

  constructor(
    readonly translate: TranslateService,
    private readonly tema: TemaService,
  ) {
    // Establecer tema claro por defecto al iniciar la aplicación
    this.tema.asignarTema('light-theme');

    // Idioma predeterminado
    const defaultLang = localStorage.getItem('lang') ?? 'es';
    this.translate.setDefaultLang(defaultLang);
    this.translate.use(defaultLang);

    // Actualizar el atributo "lang" en <html>
    document.documentElement.lang = defaultLang;
  }

  ngOnInit() {
    // You can switch language dynamically
    this.translate.use('es');
  }

  cambiarIdioma(idioma: string): void {
    this.translate.use(idioma);
    localStorage.setItem('lang', idioma);
    document.documentElement.lang = idioma;
  }
}
